import type { ReactNode } from "react";

export interface FallbackAction {
  label: string;
  onSelect: () => void;
  primary?: boolean;
}

/**
 * Wireframe fallbacks A, B and C. They differ only in copy and actions, so one
 * component keeps them visually and behaviourally consistent — every blocked
 * state gets a title, an explanation and at least one way forward.
 */
export function FallbackCard({
  testId,
  title,
  description,
  actions,
  children,
}: {
  testId: string;
  title: string;
  description: string;
  actions: readonly FallbackAction[];
  children?: ReactNode;
}) {
  return (
    <section className="panel fallback-panel" role="alert" data-testid={testId}>
      <h2>{title}</h2>
      <p className="panel-note">{description}</p>
      {children}
      <div className="fallback-actions" data-ui-control>
        {actions.map((action) => (
          <button
            key={action.label}
            className={action.primary ? "button-primary compact" : "button-quiet"}
            type="button"
            onClick={action.onSelect}
          >
            {action.label}
          </button>
        ))}
      </div>
    </section>
  );
}
